(function () {
  'use strict';

  var WISHLIST_KEY = 'suave_wishlist_v1';

  function t(key, fallback) {
    var i18n = window.__SUAVE_I18N__ || {};
    return i18n[key] || fallback;
  }

  function getActionsRoot() {
    return document.querySelector('#custom-product-container .pdp-product-actions');
  }

  function getConfig() {
    var el = document.getElementById('pdp-product-actions-config');
    if (!el) return { emailSubject: 'Check out this product', emailBody: '' };
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return { emailSubject: 'Check out this product', emailBody: '' };
    }
  }

  function getProductInfo() {
    var root = getActionsRoot();
    var titleEl = document.getElementById('dynamic-product-title');
    var mainImg = document.getElementById('main-image');
    var title = titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '';
    var url = window.location.href.split('#')[0];
    var image = mainImg && mainImg.src ? mainImg.src : '';
    var handle = '';
    var productId = '';

    if (root) {
      if (!title) title = root.getAttribute('data-product-title') || '';
      productId = root.getAttribute('data-product-id') || '';
      handle = root.getAttribute('data-product-handle') || '';
      if (!image) image = root.getAttribute('data-product-image') || '';
    }

    var pathMatch = url.match(/\/products\/([^/?#]+)/);
    if (pathMatch) handle = pathMatch[1];

    return {
      title: title,
      url: url,
      image: image,
      handle: handle,
      productId: productId
    };
  }

  function updateActionsProductData(info) {
    var root = getActionsRoot();
    if (!root || !info) return;
    if (info.title) root.setAttribute('data-product-title', info.title);
    if (info.handle) root.setAttribute('data-product-handle', info.handle);
    if (info.url) root.setAttribute('data-product-url', info.url);
    if (info.image) root.setAttribute('data-product-image', info.image);
    if (info.productId) root.setAttribute('data-product-id', info.productId);
    syncWishlistButtonState();
  }

  function readWishlist() {
    try {
      var raw = localStorage.getItem(WISHLIST_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(items) {
    try {
      localStorage.setItem(WISHLIST_KEY, JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('suave:wishlist-updated', { detail: { items: items } }));
    } catch (e) {
      /* ignore */
    }
  }

  function wishlistItemKey(info) {
    return info.handle || info.productId || info.url;
  }

  function isInWishlist(info) {
    var key = wishlistItemKey(info);
    return readWishlist().some(function (item) {
      return item.handle === key || item.id === key || item.url === info.url;
    });
  }

  function showFeedback(message) {
    var el = document.getElementById('pdp-actions-feedback');
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
    clearTimeout(showFeedback._timer);
    showFeedback._timer = setTimeout(function () {
      el.hidden = true;
    }, 3200);
  }

  function updateWishlistCountBadges() {
    var count = readWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function syncWishlistButtonState() {
    var btn = document.getElementById('pdp-save-for-later');
    if (!btn) return;
    var saved = isInWishlist(getProductInfo());
    btn.classList.toggle('is-saved', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    updateWishlistCountBadges();
  }

  function toggleWishlist() {
    var info = getProductInfo();
    var key = wishlistItemKey(info);
    if (!key) return;

    var list = readWishlist();
    var index = list.findIndex(function (item) {
      return item.handle === key || item.id === key;
    });

    if (index >= 0) {
      list.splice(index, 1);
      writeWishlist(list);
      showFeedback(t('removedFromWishlist', 'Removed from wishlist'));
    } else {
      list.push({
        id: info.productId || key,
        handle: info.handle || key,
        title: info.title,
        url: info.url,
        image: info.image,
        addedAt: Date.now()
      });
      writeWishlist(list);
      showFeedback(t('addedToWishlist', 'Added to wishlist'));
    }
    syncWishlistButtonState();
  }

  function closePanels(except) {
    ['share', 'email'].forEach(function (name) {
      if (except === name) return;
      var panel = document.getElementById('pdp-' + name + '-panel');
      var trigger = document.getElementById('pdp-' + name + '-trigger');
      if (panel) panel.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  }

  function togglePanel(name) {
    var panel = document.getElementById('pdp-' + name + '-panel');
    var trigger = document.getElementById('pdp-' + name + '-trigger');
    if (!panel || !trigger) return;

    var willOpen = panel.hidden;
    closePanels(willOpen ? name : null);
    panel.hidden = !willOpen;
    trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

    if (willOpen && name === 'share') {
      updateShareLinks();
    }
  }

  function encodeShare(text) {
    return encodeURIComponent(text || '');
  }

  function updateShareLinks() {
    var info = getProductInfo();
    var text = info.title + ' - ' + info.url;

    document.querySelectorAll('[data-share="whatsapp"]').forEach(function (el) {
      el.href = 'https://wa.me/?text=' + encodeShare(text);
    });
    document.querySelectorAll('[data-share="facebook"]').forEach(function (el) {
      el.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeShare(info.url);
    });
    document.querySelectorAll('[data-share="twitter"]').forEach(function (el) {
      el.href =
        'https://twitter.com/intent/tweet?url=' +
        encodeShare(info.url) +
        '&text=' +
        encodeShare(info.title);
    });
    document.querySelectorAll('[data-share="pinterest"]').forEach(function (el) {
      var pinUrl =
        'https://pinterest.com/pin/create/button/?url=' +
        encodeShare(info.url) +
        '&description=' +
        encodeShare(info.title);
      if (info.image) pinUrl += '&media=' + encodeShare(info.image);
      el.href = pinUrl;
    });
  }

  function copyProductLink() {
    var info = getProductInfo();
    var done = function () {
      showFeedback(t('linkCopied', 'Link copied to clipboard'));
    };

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(info.url).then(done).catch(function () {
        fallbackCopy(info.url, done);
      });
    } else {
      fallbackCopy(info.url, done);
    }
  }

  function fallbackCopy(text, cb) {
    var input = document.createElement('input');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    try {
      document.execCommand('copy');
      if (cb) cb();
    } catch (e) {
      showFeedback(text);
    }
    document.body.removeChild(input);
  }

  function buildEmailBody(template, info) {
    var body = template || '';
    body = body.replace(/\[product_title\]/gi, info.title);
    body = body.replace(/\[product_url\]/gi, info.url);
    if (body.indexOf(info.url) === -1) {
      body = body.trim() + '\n\n' + info.title + '\n' + info.url;
    }
    return body;
  }

  function sendProductEmail(email) {
    var info = getProductInfo();
    var config = getConfig();
    var subject = (config.emailSubject || 'Check out this product')
      .replace(/\[product_title\]/gi, info.title)
      .replace(/\[product_url\]/gi, info.url);
    var body = buildEmailBody(config.emailBody, info);
    var mailto =
      'mailto:' +
      encodeURIComponent(email) +
      '?subject=' +
      encodeShare(subject) +
      '&body=' +
      encodeShare(body);

    var opened = false;
    try {
      var mailLink = document.createElement('a');
      mailLink.href = mailto;
      mailLink.style.display = 'none';
      document.body.appendChild(mailLink);
      mailLink.click();
      document.body.removeChild(mailLink);
      opened = true;
    } catch (e) {
      /* fallback below */
    }

    if (!opened) {
      window.location.href = mailto;
    }

    showFeedback(t('emailClientOpened', 'Your email app should open now. Press Send in Gmail to receive the product link.'));
    closePanels(null);
  }

  function bindEvents() {
    var root = getActionsRoot();
    if (!root || root.dataset.actionsBound === 'true') return;
    root.dataset.actionsBound = 'true';

    var saveBtn = document.getElementById('pdp-save-for-later');
    if (saveBtn) {
      saveBtn.addEventListener('click', toggleWishlist);
    }

    var shareTrigger = document.getElementById('pdp-share-trigger');
    if (shareTrigger) {
      shareTrigger.addEventListener('click', function () {
        if (navigator.share) {
          var info = getProductInfo();
          navigator
            .share({ title: info.title, text: info.title, url: info.url })
            .catch(function () {
              togglePanel('share');
            });
        } else {
          togglePanel('share');
        }
      });
    }

    var emailTrigger = document.getElementById('pdp-email-trigger');
    if (emailTrigger) {
      emailTrigger.addEventListener('click', function () {
        togglePanel('email');
      });
    }

    root.querySelectorAll('[data-close-panel]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        closePanels(null);
      });
    });

    root.querySelectorAll('[data-share="copy"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        copyProductLink();
      });
    });

    var emailForm = document.getElementById('pdp-email-form');
    if (emailForm) {
      emailForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = document.getElementById('pdp-email-input');
        var email = input && input.value ? input.value.trim() : '';
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          showFeedback(t('invalidEmail', 'Please enter a valid email address.'));
          if (input) input.focus();
          return;
        }
        sendProductEmail(email);
      });
    }

    document.addEventListener('click', function (e) {
      if (!root.contains(e.target)) {
        closePanels(null);
      }
    });

    document.addEventListener('suave:pdp-product-updated', function (e) {
      if (e.detail) updateActionsProductData(e.detail);
    });

    syncWishlistButtonState();
    updateShareLinks();
    updateWishlistCountBadges();
  }

  function init() {
    bindEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  window.SuavePdpActions = {
    getWishlist: readWishlist,
    updateProduct: updateActionsProductData,
    getProductInfo: getProductInfo
  };
})();
